module.exports = __webpack_public_path__ + "static/media/meterReading.02d63f48.png";